var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{attrs:{"title":_vm.title,"type":"info","description":_vm.value,"show-icon":"","closable":false}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }